import { validateHtmlStructure } from "../utils/ValidateHtmlStructure";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const verifyCode = async (uniqueCode) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/v1/verify/verify-code`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ code: uniqueCode }),
    });

    const data = await response.json();

    const status = data?.status || "Unknown";
    const htmlContent = data?.html || "";
    const message = data?.message || "";

    // 🔒 Validate HTML structure
    const { isValid, error } = validateHtmlStructure(htmlContent);

    if (!isValid) {
      console.warn("HTML validation failed:", error);
      return {
        success: false,
        status: "Malformed",
        message: error || "Received invalid or unsafe HTML structure.",
        htmlContent: null,
        raw: data,
      };
    }

    return {
      success: status === "Verified",
      status,
      htmlContent,
      message,
      raw: data,
    };
  } catch (error) {
    console.error("API Error:", error);
    return {
      success: false,
      status: "Error",
      message: error.message || "Unknown error occurred during verification.",
    };
  }
};
